import styled, { css } from 'styled-components';

export const DropzoneWrapperSC = styled.div`
  margin-bottom: 20px;

  div {
    span.description {
      color: rgba(33, 37, 41, 0.5);
      display: block;
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 5px;
    }
  }

  .file-row {
    /* margin-top: 10px; */
    span:nth-child(1) {
      line-height: 2.14;
      margin-right: 10px;
    }
    span:nth-child(2) {
      opacity: 0.4;
      margin-right: 10px;
    }
    span:nth-child(3) {
      cursor: pointer;
      font-size: 12px;
      line-height: 1.67;
      color: ${({ theme }) => theme.colors.error.color};
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const DropzoneSC = styled.div`
  height: 120px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.primary.shades['96']};
  border: 1px dashed ${({ theme }) => theme.colors.primary.color};
  margin-bottom: 10px;

  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.colors.primary.color};
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.primary.color};

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.colors.gray.shades['96']};
      border: 1px dashed ${({ theme }) => theme.colors.gray.color};
      color: ${({ theme }) => theme.colors.gray.color};
    `}

  &:focus {
    outline: none;
  }

  text-align: center;

  img {
    display: block;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
  }

  span {
    margin-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    display: block;

    &.error {
      color: ${({ theme }) => theme.colors.error.color};
    }
  }
`;
